import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useValidateZipCode } from './useValidateZipCode';
import { GEO_ZIP_URL_PARAM } from '../constants/environment';
import { selectZipCode } from '../reducers/zipCodeReducer';
import { clearAllFilters, selectFilters } from '../reducers/filtersReducer';
import { filterClearAll, filterCurrentState } from '../utils/analyticsEventListeners';
import { INTIAL_FILTERS } from '../constants/initialFilters';
import { scrollToTop } from '../utils/scrollToTop';

interface UseZipInputReturn {
  inputValue: string;
  isNatPage: boolean;
  zipValidationLoading: boolean;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  handleClearZipCta: () => void;
  handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

const useZipInput = (): UseZipInputReturn => {
  const dispatch = useDispatch();
  const { confirmedZipcode } = useSelector(selectZipCode);
  const { confirmedFilters } = useSelector(selectFilters);
  const isNatPage = confirmedZipcode === '';
  const [inputValue, setInputValue] = useState('');
  const { validatingZip, setAlreadyValidZip, zipValidationLoading } = useValidateZipCode();

  useEffect(() => {
    if (confirmedZipcode) setInputValue(confirmedZipcode);
  }, [confirmedZipcode, setAlreadyValidZip]);

  useEffect(() => {
    if (GEO_ZIP_URL_PARAM && !confirmedZipcode) setInputValue(GEO_ZIP_URL_PARAM);
  }, [confirmedZipcode]);

  const handleClearZipCta = () => {
    setAlreadyValidZip('');
    setInputValue('');
    filterClearAll(confirmedFilters);
    dispatch(clearAllFilters());
    filterCurrentState(INTIAL_FILTERS);
    scrollToTop();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    validatingZip(inputValue);
    scrollToTop();
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    validatingZip(inputValue);
    scrollToTop();
  };

  return {
    inputValue,
    isNatPage,
    zipValidationLoading,
    setInputValue,
    handleClearZipCta,
    handleKeyDown,
    handleSubmit,
  };
};

export default useZipInput;
